<template>
  <div>
    <el-row :gutter="5" v-for="index in rowsNeed" :key="index">
      <el-col :xs="12" :sm="8" :md="8" :lg="4" :xl="4" v-for="x in 6" :key="x">
        <AuditPendenciesTypeCard v-if="list[row(index - 1, x - 1)]" :record="list[row(index - 1, x - 1)]" :count="row(index - 1, x - 1)" v-on:reload="reload" :current="type" v-on:option="option"  />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import AuditPendenciesTypeCard from './AuditPendenciesTypeCard.vue';
export default {
  components: { AuditPendenciesTypeCard },
  props: ["list", "type"],
  computed: {
    rowsNeed() {
      const lines = this.list ? this.list.length / 6 : 1;
      return Math.ceil(lines);
    },
  },
  methods: {
    reload(type) {
      this.$emit('reload', type);
    },
    option(type, action) {
      this.$emit('option', type, action);
    },
    row(index, count) {
      return (index * 6) + count;
    }
  },
}
</script>
